import { $ } from '@/utilities/helpers';
import { ENDPOINTS } from '@/components/constants';


const handleNotificationUpdate = (notification) => {
    fetchNotifications({ type: 'profile', method: 'POST' });
}

export const fetchNotifications = ({ type, read, method }) => {
    fetch(ENDPOINTS.FETCH_NOTIFICATIONS_ENDPOINT, { method, body: JSON.stringify({ type }) })
        .then(response => response.json())
        .then(data => renderNotifications(data.data))
        .finally(() => { });
}

export const updateNotification = ({ id, read, method }) => {
    fetch(ENDPOINTS.UPDATE_NOTIFICATIONS_ENDPOINT, { method, body: JSON.stringify({ id, read }) })
        .then(response => response.json())
        .then(data => handleNotificationUpdate(data.data))
        .catch(error => console.error(error))
        .finally(() => { });
}

export const getNotificationIcon = (type) => {
    switch (type) {
        case 'success':
            return '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><circle cx="15" cy="15" r="15" fill="#12B76A"/><path fill="#fff" d="m12.7 21.025-5.7-5.7L8.425 13.9l4.275 4.275L21.875 9l1.425 1.425-10.6 10.6Z"/></svg>';
        case 'error':
            return '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path fill="#EF4437" d="M14.268 3c.77-1.333 2.694-1.333 3.464 0l10.392 18c.77 1.333-.192 3-1.732 3H5.608c-1.54 0-2.502-1.667-1.732-3L14.268 3Z"/><path fill="#fff" d="M15 17V8h2v9h-2Zm0 5v-2h2v2h-2Z"/></svg>';
        case 'warning':
            return '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><circle cx="15" cy="15" r="15" fill="#EFA837"/><path fill="#fff" d="M14 17V8h2v9h-2Zm0 5v-2h2v2h-2Z"/></svg>';
        case 'informative':
            return '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><circle cx="15" cy="15" r="15" fill="#2147AA"/><path fill="#fff" fill-rule="evenodd" d="M15 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 10v-8h-3v2h1v6h-1v2h4v-2h-1Z" clip-rule="evenodd"/></svg>';
        default:
            return '';
    }
}

export const renderNotifications = (notifications) => {

    let current_order = 0;

    if ($('.js-unread-notification-count')) {
        $('.js-unread-notification-count').innerHTML = notifications.total_unread || 0;

        if (notifications.total_unread > 0) {
            $('.js-unread-notification-count').style.display = 'block';
        } else {
            $('.js-unread-notification-count').style.display = 'none';
        }
    }

    if (!$('.notifications')) return;

    if (!notifications || notifications.length === 0) {
        $('.notifications').innerHTML = '<p>No notifications found</p>';
    } else {
        $('.notifications').innerHTML = notifications.items.map(notification => {
            let icon = getNotificationIcon(notification.style);

            return /*html*/`
            <div class="notification__item [ js-note ]" data-id="${notification.id}" data-style="${notification.style}" data-read="${notification.read}" style="order: ${(notification.read) ? current_order + 100000 : current_order++}">
                <div class="notification__item__icon">
                    ${icon}
                </div>
                <div class="notification__item__content">
                    <div class="notification__item__content__heading">
                        <h4 class="no-margin">${notification.title}</h4>
                        <p class="no-margin smaller">${notification.created_nice}</p>
                    </div>
                    
                    ${notification.content ? /*html*/`
                    <div class="notification__item__content__copy">
                        <p class="no-margin">${notification.content}</p>
                    </div>
                    ` : ``}

                    ${notification.link ?/*html*/`
                    <div class="notification__item__content__actions">
                        <a href="${notification.link}" class="no-margin button button--small button--primary">${notification.link_title} <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#ffffff"><path d="M218.87-135.87q-34.48 0-58.74-24.26-24.26-24.26-24.26-58.74v-522.26q0-34.48 24.26-58.74 24.26-24.26 58.74-24.26H438.5q17.45 0 29.48 11.96Q480-800.2 480-782.84t-12.02 29.54q-12.03 12.17-29.48 12.17H218.87v522.26h522.26V-438.5q0-17.45 11.96-29.48Q765.06-480 782.42-480t29.54 12.02q12.17 12.03 12.17 29.48v219.63q0 34.48-24.26 58.74-24.26 24.26-58.74 24.26H218.87Zm522.26-546.85L423-364.59q-12.67 12.68-28.59 12.06-15.91-.62-28.58-13.3-12.68-12.67-12.68-29.2 0-16.54 12.68-29.21l316.89-316.89H617.5q-17.45 0-29.48-11.96Q576-765.06 576-782.42t12.02-29.54q12.03-12.17 29.48-12.17h165.13q17.45 0 29.48 12.02 12.02 12.03 12.02 29.48v165.13q0 17.45-11.96 29.48Q800.2-576 782.84-576t-29.54-12.02q-12.17-12.03-12.17-29.48v-65.22Z"/></svg></a>
                    </div>
                    `: ``}
                </div>
                <button class="notification__item__read [ js-toggle-notification ]">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M480.09-328.92q62.99 0 106.99-44.09 44-44.09 44-107.08 0-62.99-44.09-106.99-44.09-44-107.08-44-62.99 0-106.99 44.09-44 44.09-44 107.08 0 62.99 44.09 106.99 44.09 44 107.08 44ZM480-384q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 172q-122.31 0-225.54-64.89-103.23-64.88-165.69-170.8-5-7.62-6.81-15.64-1.8-8.02-1.8-16.46 0-8.44 1.8-16.67 1.81-8.23 6.81-15.85 62.46-105.92 165.69-170.8Q357.69-748 480-748q122.31 0 225.54 64.89 103.23 64.88 165.69 170.8 5 7.62 6.81 15.64 1.8 8.02 1.8 16.46 0 8.44-1.8 16.67-1.81 8.23-6.81 15.85-62.46 105.92-165.69 170.8Q602.31-212 480-212Zm0-268Zm0 216q112 0 207-58t146-158q-51-100-146-158t-207-58q-112 0-207 58T127-480q51 100 146 158t207 58Z"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M587.08-587.08q16.38 16.39 29.19 43.77 12.81 27.39 15.57 55.54 0 11.54-8.01 19.54t-19.14 8q-11.95 0-20.24-8-8.3-8-8.3-19.54.85-20.38-5.84-37-6.69-16.61-18.69-29.11t-28.5-18.31q-16.5-5.81-36.12-4.58-11.54.39-19.92-7.43-8.39-7.82-8.77-18.95-.39-11.54 7.42-19.93 7.81-8.38 19.35-8.76 28.92 2 56.19 14.11 27.27 12.12 45.81 30.65ZM480-696q-18.99 0-37.29 1.63-18.3 1.62-36.4 5.19-10.7 1.72-20.93-4.05t-13.07-16.04q-2.85-10.65 2.54-19.61 5.38-8.96 16.3-10.83 22.39-4.52 44.39-6.4Q457.55-748 480-748q125.92 0 232.85 63.5Q819.77-621 875.97-508.57q3.87 7.49 5.18 14.24 1.31 6.75 1.31 14.33t-1.5 14.33q-1.5 6.75-4.5 14.36-18.13 36.28-44.07 67.64-25.93 31.36-56.55 59.21-8.3 7.31-18.76 6.88-10.47-.42-18.16-9.12-7.69-8.71-6.38-18.62 1.31-9.91 9.61-18.22 29.08-24.54 51.75-53.65Q816.57-446.31 833-480q-49-101-144.5-158.5T480-696Zm0 484q-123.31 0-227.54-64.5-104.23-64.5-165.38-172-4.92-7.42-6.23-15.37-1.31-7.95-1.31-16.16 0-8.2 1.5-16.32 1.5-8.11 6.5-15.34 25.31-45.77 57.8-85.14 32.5-39.36 74.66-70.63l-82.31-81.93q-8.3-7.92-8.69-17.69-.38-9.77 8.31-18.46 8.69-8.69 18.58-8.69 9.88 0 18.57 8.69l611.08 611.08q8.31 8.31 8.31 18.07 0 9.77-8.31 18.08-8.69 8.69-18.58 8.69-9.88 0-18.57-8.69L642.62-243.85q-38.79 16.69-79.64 24.27Q522.14-212 480-212ZM257.16-629.31q-41.16 29.16-75.2 65.92Q147.92-526.62 127-480q49 101 144.5 158.5T480-264q31.98 0 62.84-4.46 30.85-4.46 60.47-14.69L543.69-342q-15.15 7.31-31.27 10.19-16.11 2.89-32.42 2.89-63.08 0-107.08-44t-44-107.08q0-16.31 4.08-32.42 4.08-16.12 9-31.27l-84.84-85.62ZM528-528Zm-76.77 86.77Z"/></svg>
                </button>
            </div>
        `;
        }
        ).join('');
    }
}



let $notifications = $('.notifications');

if ($notifications) {
    fetchNotifications({ type: 'profile', method: 'POST' });

    $notifications.addEventListener('click', (e) => {

        if (e.target.classList.contains('js-toggle-notification')) {
            e.preventDefault();
            let $notification = e.target.closest('.js-note');
            let id = $notification.dataset.id;
            let is_read = $notification.dataset.read === 'true' ? true : false;

            updateNotification({ id, read: !is_read, method: 'POST' });
            $notification.dataset.read = !is_read;
        }
    });
} else if ($('.js-unread-notification-count')) {
    fetchNotifications({ type: 'profile', method: 'POST' });
}


